<template>
    <v-container
        fluid
        class="header-toolbar pa-0"
    >
        <v-row>
            <v-col
                class="header-toolbar-left"
                cols="6"
            >
                <div>
                    <router-link
                        to="/about/1/1"
                        class="header-toolbat-link"
                    >
                        <svg
                            width="19"
                            height="24"
                            viewBox="0 0 19 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M4.75 18.3H14.25V16.8H4.75V18.3ZM4.75 13.5H14.25V12H4.75V13.5ZM2.375 24C1.72187 24 1.16276 23.765 0.697656 23.295C0.232552 22.825 0 22.26 0 21.6V2.4C0 1.74 0.232552 1.175 0.697656 0.705C1.16276 0.235 1.72187 0 2.375 0H11.875L19 7.2V21.6C19 22.26 18.7674 22.825 18.3023 23.295C17.8372 23.765 17.2781 24 16.625 24H2.375ZM11.875 8.4V1.5H1.48438V22.5H17.5156V8.4H11.875Z"
                                fill="#FFFFFF"
                            />
                        </svg>
                        <div class="header-toolbar-text d-none d-sm-block">
                            Документы
                        </div>
                    </router-link>
                </div>
                <div class="ml-14">
                    <router-link
                        to="/library"
                        class="header-toolbat-link"
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M5.124 19.2L5.12727 10.8H6.65455L6.66 19.2H5.124ZM11.232 19.2L11.2364 10.8H12.7636L12.768 19.2H11.232ZM0 24V22.5H24V24H0ZM17.34 19.2L17.3455 10.8H18.8727L18.876 19.2H17.34ZM0 7.5V6L12 0L24 6V7.5H0ZM3.3 6H20.7L12 1.5L3.3 6Z"
                                fill="#FFFFFF"
                            />
                        </svg>
                        <div class="header-toolbar-text d-none d-sm-block">
                            Библиотека
                        </div>
                    </router-link>
                </div>
            </v-col>
            <v-col
                class="header-toolbar-right"
                cols="6"
            >
                <div v-if="isAuthenticated">
                    <img
                        class="ml-4 user-avatar"
                        :src="userImg"
                        height="20"
                        width="20"
                        @click="
                            () => {
                                this.isToggleDropdown = !this.isToggleDropdown
                            }
                        "
                    />
                    <UserDropdown
                        v-if="this.isToggleDropdown"
                        @close-dropdown="
                            () => {
                                this.isToggleDropdown = false
                            }
                        "
                    />
                </div>
                <router-link
                    v-else
                    to="/authorization"
                >
                    <svg
                        class="ml-6"
                        width="24"
                        height="16"
                        viewBox="0 0 24 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8 1.12093C9.16 1.12093 10.8651 1.97674 10.8651 4.02326C10.8651 5.2093 10.2326 6.81395 8 6.81395C6.84 6.81395 5.2093 5.88372 5.13488 4.02326C5.06046 2.16279 6.84 1.12093 8 1.12093ZM8 10.0465C13.2093 10.4186 14.8837 12.36 14.8837 13V14.8837H1.11628V13C1.11628 12.36 2.97674 10.2326 8 10.0465ZM8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0ZM8 9C5.33 9 0 10.34 0 13V16H16V13C16 10.34 10.67 9 8 9Z"
                            fill="#FFFFFF"
                        />
                    </svg>
                </router-link>
                <!-- <a
                    id="specialButton"
                    href="#"
                >
                    <svg
                        id="glazd"
                        class="ml-6 d-none d-sm-block"
                        width="24"
                        height="16"
                        viewBox="0 0 24 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12.0032 12.5333C13.292 12.5333 14.3864 12.0923 15.2864 11.2102C16.1864 10.3281 16.6364 9.257 16.6364 7.99685C16.6364 6.73673 16.1853 5.66667 15.2831 4.78667C14.381 3.90667 13.2856 3.46667 11.9968 3.46667C10.708 3.46667 9.61364 3.90772 8.71364 4.78981C7.81364 5.67189 7.36364 6.743 7.36364 8.00315C7.36364 9.26327 7.81471 10.3333 8.71686 11.2133C9.61898 12.0933 10.7144 12.5333 12.0032 12.5333ZM11.9936 10.9867C11.1433 10.9867 10.4227 10.6957 9.83182 10.1137C9.24091 9.53176 8.94545 8.82509 8.94545 7.99373C8.94545 7.16236 9.24305 6.45778 9.83823 5.88C10.4334 5.30222 11.1562 5.01333 12.0064 5.01333C12.8567 5.01333 13.5773 5.30431 14.1682 5.88627C14.7591 6.46824 15.0545 7.17491 15.0545 8.00627C15.0545 8.83764 14.757 9.54222 14.1618 10.12C13.5666 10.6978 12.8438 10.9867 11.9936 10.9867ZM12 16C9.34545 16 6.94545 15.2622 4.8 13.7867C2.65455 12.3111 1.05455 10.3822 0 8C1.05455 5.61778 2.65455 3.68889 4.8 2.21333C6.94545 0.737778 9.34545 0 12 0C14.6545 0 17.0545 0.737778 19.2 2.21333C21.3455 3.68889 22.9455 5.61778 24 8C22.9455 10.3822 21.3455 12.3111 19.2 13.7867C17.0545 15.2622 14.6545 16 12 16ZM11.9954 14.4C14.1985 14.4 16.2227 13.8178 18.0682 12.6533C19.9136 11.4889 21.3182 9.93778 22.2818 8C21.3182 6.06222 19.9152 4.51111 18.0728 3.34667C16.2304 2.18222 14.2077 1.6 12.0046 1.6C9.80154 1.6 7.77727 2.18222 5.93182 3.34667C4.08636 4.51111 2.67273 6.06222 1.69091 8C2.67273 9.93778 4.08483 11.4889 5.92721 12.6533C7.76961 13.8178 9.79234 14.4 11.9954 14.4Z"
                            fill="#FFFFFF"
                        />
                    </svg>
                </a>
                <div class="header-toolbar-text ml-6">RUS</div>
                <div class="header-toolbar-language-border"></div>
                <div class="header-toolbar-text ml-6">EN</div> -->
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { useAuthStore } from '@/store/auth'
import UserDropdown from './UserDropdown.vue'

export default {
    name: 'HeaderLogo',
    components: {
        UserDropdown
    },
    computed: {
        isAuthenticated() {
            let authStore = useAuthStore()
            if (authStore.email) {
                return true
            }
            return false
        },
        userImg(){
            let authStore = useAuthStore()        
            if (authStore.profile_pic){
                return document.location.origin + '/' + authStore.profile_pic
            }
            return '/img/empty_avatar.png'
        }
    },
    data: function () {
        return { isToggleDropdown: false }
    }
}
</script>
